import React from 'react';

const InfoModal = ({ 
  show, 
  onClose, 
  title, 
  children, 
  theme,
  buttonText = 'Close' // Default button text
}) => (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: show ? 'flex' : 'none',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
  }}>
    <div style={{
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '8px',
      maxWidth: '600px',
      textAlign: 'center',
      color: 'black',
    }}>
      <h3 style={{ marginTop: 0 }}>{title}</h3>
      <div style={{ marginBottom: '20px' }}>
        {children}
      </div>
      <button 
        onClick={onClose}
        style={{
          backgroundColor: theme.accentColor,
          color: 'white',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '5px',
          cursor: 'pointer',
        }}
      >
        {buttonText}
      </button>
    </div>
  </div>
);

export default InfoModal;
